<template>
  <div class="base-timer d-flex align-items-center justify-content-center f-20">
    <svg
      class="base-timer__svg"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g class="base-timer__circle">
        <circle class="base-timer__path-elapsed" cx="50" cy="50" r="46.5" />
        <path
          :stroke-dasharray="circleDasharray"
          class="base-timer__path-remaining"
          d="
            M 50, 50
            m -45, 0
            a 45,45 0 1,0 90,0
            a 45,45 0 1,0 -90,0
          "
        ></path>
      </g>
    </svg>
    <span
      class="base-timer__label f-Overpass f-w-700 d-flex justify-content-center align-items-center f-18"
    >
      {{ formattedTimeLeft }}
    </span>
  </div>
</template>

<script>
export default {
  name: "pomodoroTimer",
  props: {
    timeLeft: {
      type: Number,
      required: true,
    },
    limit: Number,
  },
  data() {
    return {
      timerInterval: null,
      timeLimit: 120,
    };
  },

  computed: {
    formattedTimeLeft() {
      const timeLeft = this.timeLeft;
      if (timeLeft <= 0) {
        return "0:00";
      }

      // Convert milliseconds to seconds
      const totalSeconds = Math.floor(this.timeLeft / 1000);

      // Extract minutes and seconds
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      // The output in MM:SS format
      return `${minutes}:${seconds}`;
    },
    circleDasharray() {
      const FULL_DASH_ARRAY = 283;
      return `${(this.timeFraction * FULL_DASH_ARRAY).toFixed(0)} 283`;
    },

    timeFraction() {
      return this.timeLeft / (this.limit * 1000);
    },
  },
};
</script>
<!-- lang="scss" -->
<style scoped lang="scss">
.base-timer {
  position: relative;
  width: 80px;
  height: 80px;

  &__label {
    position: absolute;
    width: 80px;
    height: 80px;
    top: 0;
    color: #206cfe;
  }
  /* Removes SVG styling that would hide the time label */
  &__circle {
    fill: none;
    stroke: none;
  }

  &__path-remaining {
    stroke-width: 7px;
    stroke-linecap: round;
    transform: rotate(90deg);
    transform-origin: center;
    transition: stroke-dasharray 1s linear all;
    stroke: #206cfe;
  }

  &__svg {
    transform: scaleX(1);
  }

  /* The SVG path that displays the timer's progress */
  &__path-elapsed {
    stroke-width: 7px;
    stroke: #d2e6ff;
  }
}
</style>
